// extracted by mini-css-extract-plugin
module.exports = {"flowModalWrapper":"BlockApplyModal_flowModalWrapper__2d0a7"};